import {
  EditContextProvider,
  SimpleForm,
  useEditController,
  TextInput,
} from "react-admin";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { useParams } from "react-router-dom";

export const UserRoleStatusEdit = (props: any) => {
  const { id } = useParams();
  const controller = useEditController({
    resource: "user-role-status/crud",
    mutationMode: "pessimistic",
    id,
  });
  return (
    <EditContextProvider value={controller}>
      <SimpleForm>
        <PageTopBreadcrumb
          title="Status de Cargos e Funções"
          firstPath="/#/user-role-status/crud"
          secondTitle="Editando"
          thirdTitle={controller && controller.record && controller.record.name}
          actionType="show"
        />
        <Card sx={{ padding: 2, marginBottom: 3, width: "100%" }}>
          <CardHeader title="Status de Cargos e Funções" />
          <CardContent>
            <Grid container spacing={0.5}>
              <Grid item xs={12}>
                <TextInput
                  source="id"
                  label="ID"
                  fullWidth
                  helperText={false}
                  disabled
                />
                <TextInput
                  source="name"
                  label="Nome"
                  fullWidth
                  helperText={false}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </SimpleForm>
    </EditContextProvider>
  );
};
